/**
 * Форматирует пропускную способность, добавляя единицу измерения
 */
export const formatCapacity = (capacity: string | null | undefined): string => {
  if (!capacity) return "";
  return `${capacity} чел./час`;
};

/**
 * Форматирует длину, добавляя единицу измерения (по умолчанию "м")
 */
export const formatLength = (
  length: string | null | undefined,
  unit?: string,
): string => {
  if (!length) return "";
  if (!unit) return length;
  return `${length} ${unit}`;
};
